import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "@/App";

// Patch ResizeObserver to prevent harmless loop error (Radix UI + Dialog issue)
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        try { callback(entries, observer); } catch (e) {}
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
